import useAddress from './useAddress'
import HouseType from '@/containers/SubscriptionFormPageNew/Components/Address/Fields/Default/HouseType'
import ResidenceType from './Fields/Default/ResidenceType'
import TenantType from './Fields/Default/TenantType'
import AdditionalInformation from './Fields/Default/AdditionalInformation'
import StreetNumber from './Fields/Default/StreetNumber'
import StreetName from './Fields/Default/StreetName'
import Zipcode from './Fields/Default/Zipcode'
import City from './Fields/Default/City'
import Floor from './Fields/Default/Floor'
import ApartmentNumber from './Fields/Default/ApartmentNumber'
import Province from './Fields/Default/Province'
import IsResident from './Fields/Default/IsResident'
import Consumption from '@/containers/SubscriptionFormPageNew/Components/Address/Fields/Default/Consumption'
import { t } from 'i18next'
import { MultipleInputsContainer, StyledTitle } from './styled-components'
import EditAddressFields from '@/containers/SubscriptionFormPageNew/Components/Address/Fields/Default/EditAddressFields'
import FillEnergyLandscape from '@/containers/SubscriptionFormPageNew/Components/Address/Fields/Default/FillEnergyLandscape'
import EnergyLandscape from '@/containers/SubscriptionFormPageNew/Components/Address/Fields/Default/EnergyLandscape'
import ZipcodeValidationWarning from '@/containers/SubscriptionFormPageNew/Components/MeterSaveButton/ZipcodeValidationWarning'
import SDButton from '@/shared/components/SDComponentsNewDesign/SDButton/SDButton'

const Address = ({ hidden, title }) => {
  const { addressIsSaving, LocalizedAddressSearchComponent, saveActiveAddress, hasZipcodeWarning } = useAddress()

  if (hidden || !LocalizedAddressSearchComponent) {
    return null
  }

  return (
    <>
      <StyledTitle>{title}</StyledTitle>
      <ResidenceType />
      <HouseType />
      <TenantType />
      <IsResident />
      <LocalizedAddressSearchComponent />
      <EditAddressFields />
      <MultipleInputsContainer>
        <Zipcode />
        <City />
      </MultipleInputsContainer>
      <ZipcodeValidationWarning showWarning={hasZipcodeWarning} />
      <StreetNumber />
      <StreetName />
      <Province />
      <Floor />
      <ApartmentNumber />
      <AdditionalInformation />
      <Consumption />
      <FillEnergyLandscape />
      <EnergyLandscape />
      <div>
        <SDButton style={{ width: '100%' }} isLoading={addressIsSaving} onClick={saveActiveAddress}>
          {t('common:save')}
        </SDButton>
      </div>
    </>
  )
}

export default Address
